import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function StripeCancelPage() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const portalId = params.get("portal_id") || "";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#323c44] px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#323c44] p-10 text-center">
        <XCircle className="mx-auto mb-4 h-12 w-12 text-slate-500" />
        <h2 className="text-xl font-bold text-white">Payment cancelled</h2>
        <p className="mt-2 text-sm text-slate-400">
          No charge was made. You can try again whenever you're ready.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <button
            type="button"
            onClick={() =>
              navigate(portalId ? `/stripe/checkout?portal_id=${portalId}` : "/connections")
            }
            className="rounded-lg bg-[#50e3c2] px-6 py-2.5 text-sm font-semibold text-[#323c44] hover:bg-[#57c1a9]"
          >
            Choose a plan
          </button>
          <button
            type="button"
            onClick={() => navigate("/connections")}
            className="rounded-lg border border-white/10 px-6 py-2.5 text-sm text-slate-400 hover:bg-white/5"
          >
            Back to app
          </button>
        </div>
      </div>
    </div>
  );
}
